
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'siat-loading-spinner',
  templateUrl: './loading-spinner.component.html',

  imports: [MatProgressSpinnerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './loading-spinner.component.scss',
})
export class LoadingSpinnerComponent {
  /**
   * The flag for the visibility of the spinner.
   */
  @Input()
  visible: boolean;
}
